import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SnackBarComponent } from '../../components/snack-bar/snack-bar.component';
import { environment } from '../../../environments/environment';
import { CreateSupplierModalComponent } from '../../_views/create-supplier/create-supplier-modal/create-supplier-modal.component';
import { TooltipModule } from 'primeng/tooltip';
import { ViewModeService } from '../../services/view-mode/view-mode.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { MENUS_HOME } from '../../_models/configuration.model';

@Component({
    selector: 'app-base-layout',
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, BreadcrumbComponent, SnackBarComponent, CreateSupplierModalComponent, TooltipModule],
    templateUrl: './base-layout.component.html',
    styleUrls: ['./base-layout.component.scss']
})
export class BaseLayoutComponent {
  env = environment;
  isCollapsed: boolean = true;

  private readonly menus = toSignal(inject(ConfigurationService).misMenus$, { initialValue: [] as string[] });

  constructor(public viewModeService: ViewModeService) {}

  ve(...ids: readonly string[]): boolean {
    return ids.some(id => this.menus().includes(id));
  }

  get veHome(): boolean {
    return this.ve(...MENUS_HOME);
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }
}
